import { type FieldError, type UseFormRegisterReturn } from 'react-hook-form';
import { extractTextContent, type RichTextNode, richTextParser } from '@bedrock/core/contentful';
import { Checkbox, CheckboxGrid } from '@bedrock/ui/checkbox';
import { ErrorMessage } from './error-message';

type CheckboxFieldProps = Readonly<{
  id: string;
  label?: RichTextNode;
  register: UseFormRegisterReturn;
  error?: FieldError;
}>;

export function CheckboxField({ id, label, register, error }: CheckboxFieldProps) {
  return (
    <CheckboxGrid className="text-background [&_.br-checkbox-wrapper_input:checked+_.br-checkbox]:border-primary [&_.br-checkbox-wrapper_input:checked+_.br-checkbox]:bg-primary-foreground [&_.br-checkbox-wrapper_input:checked+_.br-checkbox]:text-primary w-full [&_.br-checkbox-wrapper]:mt-0 [&_.br-checkbox-wrapper]:self-start">
      <Checkbox
        {...register}
        className="border-primary bg-primary-foreground rounded-sm"
        defaultChecked={false}
        id={id}
      />
      {label ? (
        <label
          aria-label={extractTextContent(label)}
          className="br-label br-type-functional-sm-strong text-background flex flex-col gap-[0.7rem] [&_a]:underline"
          dangerouslySetInnerHTML={{ __html: richTextParser(label) }}
          htmlFor={id}
        />
      ) : null}
      <div />
      <ErrorMessage error={error} />
    </CheckboxGrid>
  );
}
